<template>
  <div class="home">
    <div class="wrapper" v-if="init">
      <table class="tg">
        <tbody>
          <tr>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[5]"
                palace-id="5"
                ref="palace5"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[6]"
                palace-id="6"
                ref="palace6"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[7]"
                palace-id="7"
                ref="palace7"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[8]"
                palace-id="8"
                ref="palace8"
              />
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[4]"
                palace-id="4"
                ref="palace4"
              />
            </td>
            <td class="" colspan="2" rowspan="2">
              <div class="data-cell">
                <div
                  class="main-data"
                  :style="[isClass ? 'fontSize: 20px' : '']"
                >
                  <div>
                    <strong>{{ $t('homeTitle') }}</strong>
                  </div>
                  <div v-if="init">
                    <div><strong>姓名</strong>：{{ user.name }}</div>
                    <div>
                      <strong>{{ $t('home.watchTime') }}</strong
                      >：<br />{{ user.birthday }}
                    </div>
                    <div>
                      <strong>{{ $t('apparentSolarTime') }}</strong
                      >：<br />{{ apparentSolarTime }}
                    </div>
                    <div>
                      <strong>{{ $t('lunarTime') }}</strong
                      >：{{ lunarBirthday }}
                    </div>
                    <div>
                      <strong> {{ $t('gender') }} </strong>：{{
                        gender == 1 ? '男' : '女'
                      }}，<strong>{{ $t('fakeAge') }}</strong
                      >：{{ age }}
                    </div>
                    <div>
                      <strong>{{ $t('bornTZ') }}</strong
                      >：{{ $t('timezone.' + timezone + '_name') }}
                    </div>
                    <div><strong>出生地</strong>：{{ areaName }}</div>
                    <div>
                      <strong>{{ $t('longitude') }}</strong
                      >：{{ longitude }}
                    </div>
                    <div>
                      <button @click="toInput()">{{ $t('inputData') }}</button>
                    </div>
                  </div>
                </div>
                <div>
                  <button @click="toExplain()">{{ $t('home.explain') }}</button>
                </div>
                <div
                  style="
                    background-image: url('/image/80M.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    flex-grow: 1;
                    max-height: 66px;
                  "
                  v-if="!isClass"
                ></div>
                <div
                  style="
                    background-image: url('/image/80M-c.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    flex-grow: 1;
                    max-height: 132px;
                  "
                  v-else
                ></div>
                <div class="copyright-data">{{ $t('copyright') }}</div>
              </div>
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[9]"
                palace-id="9"
                ref="palace9"
              />
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[3]"
                palace-id="3"
                ref="palace3"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[10]"
                palace-id="10"
                ref="palace10"
              />
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[2]"
                palace-id="2"
                ref="palace2"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[1]"
                palace-id="1"
                ref="palace1"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[0]"
                palace-id="0"
                ref="palace0"
              />
            </td>
            <td class="tg-0lax">
              <palace-component
                :palace="pan.palace[11]"
                palace-id="11"
                ref="palace11"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="option-wrapper" v-if="init">
      <table style="table-layout: fixed; width: 100%">
        <tbody>
          <tr>
            <td>大限</td>
            <td v-for="item in [...Array(10).keys()]" :key="item">
              <decade-button-component :decade="item" @set-decade="setDecade" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment-timezone'
import axios from 'axios'

import { PanUtil } from '@/util'
import PalaceComponent from '@/components/PalaceComponent.vue'
import DecadeButtonComponent from '@/components/DecadeButtonComponent.vue'
import { AREAS } from '@/constant/china'
import { TIMEZONE } from '@/constant/timezone'
import { CHINESE_NEW_YEAR } from '@/constant/chinese-new-year'

const DETAIL_LIST = ['Asia/Shanghai', 'Asia/Kuala_Lumpur', 'Asia/Kuching']

export default {
  name: 'HomeView',
  data: function () {
    return {
      testYear: 1970,
      testMonth: 7,
      testDay: 15,
      testHour: 12,
      testMinute: 0,
      gender: '1',
      name: '',
      timezone: '',
      longitude: 0,
      selectPlace: '-1',
      apparentSolarTime: '',
      daylight: 0,
      pan: {},
      init: false,
      showState: 'LIFE',
      customLifePalacePosition: -1,
      thisDecade: 0,
      thisYear: moment().tz('Etc/GMT-8').year(),
    }
  },
  components: {
    PalaceComponent,
    DecadeButtonComponent,
  },
  created: async function () {
    // 首先获取视窗高度，再乘以1%得到vh单位的值
    let vh = window.innerHeight * 0.01
    // 把--vh的值设置到文档的根元素中
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.timezone = timeZone
    try {
      this.longitude = Math.round(
        TIMEZONE.find((item) => item.timezone == this.timezone).longitude
      )
    } catch (error) {
      if (this.$i18n.locale == 'zh-TW') {
        this.timezone = 'Asia/Taipei'
      } else {
        this.timezone = 'Asia/Shanghai'
      }
      this.longitude = Math.round(
        TIMEZONE.find((item) => item.timezone == this.timezone).longitude
      )
    }

    if (window.localStorage.getItem('user') !== null) {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const date = moment.tz(user.birthday, 'YYYY-MM-DD HH:mm', 'Etc/GMT-8')

      this.testYear = date.year()
      this.testMonth = date.month() + 1
      this.testDay = date.date()

      this.testHour = date.hour()
      this.testMinute = date.minute()

      this.gender = user.gender
      this.name = user.name

      this.timezone = user.timezone || this.timezone
      this.longitude = user.longitude

      this.selectPlace = user.selectPlace || 110000

      this.daylight = user.daylight || 0
    }

    const now = moment().tz('Etc/GMT-8')
    this.thisYear = now.year()
    const chineseNewYearDate = CHINESE_NEW_YEAR[now.year()]
    const chineseNewYear = moment(
      new Date(now.year(), chineseNewYearDate[0] - 1, chineseNewYearDate[1])
    ).tz('Etc/GMT-8')
    if (now.isBefore(chineseNewYear)) {
      this.thisYear--
    }

    await this.getPan()
    this.init = true
  },
  mounted: async function () {},
  computed: {
    user: function () {
      const birthday = moment.tz(
        this.birthdayDate +
          ' ' +
          String(this.testHour).padStart(2, '0') +
          ':' +
          String(this.testMinute).padStart(2, '0'),
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )

      return {
        name: this.name,
        birthday: birthday.format('YYYY-MM-DD HH:mm'),
        gender: this.gender,
        timezone: this.timezone,
        longitude: this.longitude,
        daylight: this.daylight,
      }
    },
    birthdayDate: function () {
      const d = this.testYear + '-' + this.testMonth + '-' + this.testDay
      return d
    },
    isClass: function () {
      return process.env.VUE_APP_USE_STARS === 'CLASS'
    },
    areaLevel1: function () {
      return AREAS.filter(function (item) {
        return item.level == 1
      })
    },
    areaLevel2: function () {
      return AREAS.filter(function (item) {
        return item.level == 2
      })
    },
    areaLevel3: function () {
      return AREAS.filter(function (item) {
        return item.level == 3
      })
    },
    areaName: function () {
      try {
        if (DETAIL_LIST.includes(this.timezone)) {
          const location = AREAS.find((item) => item.code == this.selectPlace)
          if (location.level == 3) {
            const level2 = this.areaLevel2.find(
              (item) => item.code == location.parentCode
            )
            const level1 = this.areaLevel1.find(
              (item) => item.code == level2.parentCode
            )
            return (
              this.$i18n.t(level1.name) +
              '-' +
              this.$i18n.t(level2.name) +
              '-' +
              this.$i18n.t(location.name)
            )
          } else if (location.level == 2) {
            const level1 = this.areaLevel1.find(
              (item) => item.code == location.parentCode
            )
            return this.$i18n.t(level1.name) + '-' + this.$i18n.t(location.name)
          }
          return this.$i18n.t(location.name)
        } else if (this.timezone == 'Asia/Taipei') {
          return this.$i18n.t('input.place.taiwan')
        } else if (this.timezone == 'Asia/Hong_Kong') {
          return this.$i18n.t('input.place.hongkong')
        } else if (this.timezone == 'Asia/Macau') {
          return this.$i18n.t('input.place.macau')
        } else {
          return this.$i18n.t('input.place.other')
        }
      } catch (error) {
        return this.$i18n.t('input.place.other')
      }
    },
    age: function () {
      const lunarBirthDate = this.pan.birthdayLunar1.split(' ')[0]
      const year = lunarBirthDate.split('/')[0]

      const now = moment().tz('Etc/GMT-8')
      let thisYear = now.year()
      const chineseNewYearDate = CHINESE_NEW_YEAR[now.year()]
      const chineseNewYear = moment(
        new Date(now.year(), chineseNewYearDate[0] - 1, chineseNewYearDate[1])
      ).tz('Etc/GMT-8')
      if (now.isBefore(chineseNewYear)) {
        thisYear--
      }

      const age = thisYear - year + 1

      return age
    },
    lunarBirthday: function () {
      const lunarBirthDate = this.pan.birthdayLunar1.split(' ')[0]
      const year = lunarBirthDate.split('/')[0]
      const month = lunarBirthDate.split('/')[1]
      const date = lunarBirthDate.split('/')[2]
      return PanUtil.getLunarChineseDate(year, month, date, this.pan.isLeap)
    },
    fiveElement: function () {
      if (this.pan.FiveElement == 2) {
        return '水二局'
      } else if (this.pan.FiveElement == 3) {
        return '木三局'
      } else if (this.pan.FiveElement == 4) {
        return '金四局'
      } else if (this.pan.FiveElement == 5) {
        return '土五局'
      } else if (this.pan.FiveElement == 6) {
        return '火六局'
      } else return ''
    },
  },
  methods: {
    submit: async function () {
      await this.getPan()
      this.$refs.palace0.resetFontSize()
      this.$refs.palace1.resetFontSize()
      this.$refs.palace2.resetFontSize()
      this.$refs.palace3.resetFontSize()
      this.$refs.palace4.resetFontSize()
      this.$refs.palace5.resetFontSize()
      this.$refs.palace6.resetFontSize()
      this.$refs.palace7.resetFontSize()
      this.$refs.palace8.resetFontSize()
      this.$refs.palace9.resetFontSize()
      this.$refs.palace10.resetFontSize()
      this.$refs.palace11.resetFontSize()
    },
    getApparentSolarTime: async function () {
      const cloneBirthday = moment.tz(
        this.user.birthday,
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )
      if (this.daylight == 1) {
        cloneBirthday.hour(cloneBirthday.hour() - 1)
      }

      let location = AREAS.find((item) => item.code == this.selectArea)
      if (!location) {
        this.selectArea = 110000
        location = AREAS.find((item) => item.code == this.selectArea)
      }
      while (!location.longitude) {
        location = AREAS.find((item) => item.code == location.parentCode)
      }

      const payload = {
        year: cloneBirthday.year(),
        month: cloneBirthday.month() + 1,
        date: cloneBirthday.date(),
        hour: cloneBirthday.hour(),
        minute: cloneBirthday.minute(),
        longitude: location.longitude,
        timezone: 'Asia/Shanghai',
      }

      const { data: resp } = await axios.get(
        'https://api-util.taotaoxi.cn/apparent-solar-time',
        {
          params: payload,
        }
      )

      const ret =
        resp.year +
        '/' +
        resp.month +
        '/' +
        resp.date +
        ' ' +
        String(resp.hour).padStart(2, '0') +
        ':' +
        String(resp.minute).padStart(2, '0')

      this.apparentSolarTime =
        resp.year +
        '-' +
        resp.month +
        '-' +
        resp.date +
        ' ' +
        String(resp.hour).padStart(2, '0') +
        ':' +
        String(resp.minute).padStart(2, '0')

      return ret
    },
    getPan: async function () {
      // let trueSolarTime = await this.getApparentSolarTime()

      // thisYear: moment().tz('Etc/GMT-8').year(),

      let location = AREAS.find((item) => item.code == this.selectArea)
      if (!location) {
        this.selectArea = 110000
        location = AREAS.find((item) => item.code == this.selectArea)
      }
      while (!location.longitude) {
        location = AREAS.find((item) => item.code == location.parentCode)
      }

      const payload = {
        thisYear: this.thisYear,
        name: this.user.name,
        gender: this.user.gender,
        birthday: this.user.birthday,
        longitude: this.user.longitude,
        timezone: this.user.timezone,
        daylight: this.user.daylight,
      }
      const resp = await axios.post(
        // 'http://bryanwu.taotaoxi.cn/AIFortuneTeller/GetOneLifePan',
        'https://api.taotaoxi.cn/ming-pan/get-pan/v3',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )

      this.pan = {
        ...resp.data,
        palace: PanUtil.processPalace(resp.data),
        minDecadeAge: resp.data.FiveElement,
        ...PanUtil.getLifePalace(resp.data),
      }
      this.apparentSolarTime = resp.data.apparentSolarTime

      // let re = new RegExp('鹹', 'g')

      // const cnString = tw2cn(JSON.stringify(this.pan)).replace(re, '咸')

      // this.pan = JSON.parse(cnString)

      // window.localStorage.setItem('user', JSON.stringify(this.user))
    },
    setDecade: async function () {
      await this.getPan()
      this.showState = 'DECADE'
      // this.resetCustomLifePalacePosition()
    },
    toInput: function () {
      this.$router.push({ name: 'InputData' })
    },
    toExplain: function () {
      this.$router.push({
        name: 'ExplainList',
        params: { palace: JSON.stringify(this.pan.palace) },
      })
    },
  },
}
</script>

<style scoped>
.home {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  display: flex;
  font-size: 14px;
  flex-direction: column;
}

.wrapper {
  margin: 10px;
  flex: 1;
  display: flex;
}

.table-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.table-middle-wrapper {
  flex: 2;
}
.table-middle-cell {
  display: flex;
  flex: 1;
}
.table-middle-center-cell {
  flex: 2;
}

.data-cell {
  height: 100%;
  flex: 1;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.main-data {
  flex: 1;
  font-size: 12px;
  word-break: break-all;
}

.palace-cell {
  flex: 1;
  border: 1px solid black;
  border-bottom: none;
  border-right: none;
  display: flex;
  padding: 1px;
  position: relative;
}
.palace-cell-right {
  border-right: 1px solid black;
}

.palace-cell-bottom {
  border-bottom: 1px solid black;
}
.copyright-data {
  font-size: 12px;
}
.inline-block {
  display: inline-block;
}

.tg {
  border-collapse: collapse;
  border-spacing: 0;
  flex: 1;
  height: 100%;
}
.tg td {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  overflow: hidden;
  word-break: normal;
}
.tg .tg-0lax {
  word-wrap: break-word;
  table-layout: fixed;
  width: 25%;
  height: 25%;
  position: relative;
}
</style>
